import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as actions from './actions'
import * as api from './api'
import { getSortedIds } from 'helpers/jsonAPI'
import { message } from 'antd'

function* fetchArcAdsWorker({ payload }) {
  try {
    const { data } = yield call(api.getArcAds, payload)
    if (data) {
      yield put(
        actions.fetchArcAdsSuccess({
          ...payload,
          ads: data.data,
          included: data.included,
          sortedIds: getSortedIds(data.data),
          pageCount: data.meta?.pagination?.pages || 1,
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcAdsFailure())
  }
}

function* fetchArcAdDetailsWorker({ payload }) {
  try {
    const { data } = yield call(api.getArcAd, payload.id)
    if (data) {
      yield put(
        actions.fetchArcAdDetailsSuccess({
          ad: data.data,
          included: data.included || [],
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcAdDetailsFailure())
  }
}

function* fetchArcAdSourcesWorker({ payload }) {
  try {
    const { data } = yield call(api.getArcAdSources)
    if (data) {
      yield put(
        actions.fetchArcAdSourcesSuccess({
          sources: data || [],
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcAdSourcesFailure())
  }
}

function* createArcAdWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    yield call(api.createArcAd, payload.data)
  } catch (error) {
    console.error(error)
    message.error('Failed to create arc ad')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* updateArcAdWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    const { data } = yield call(api.updateArcAd, payload.data)
    if (data) {
      yield put(actions.updateArcAdSuccess(payload))
      message.success('Arc ad updated successfully')
      if (payload.callback) {
        payload.callback()
      }
    } else {
      yield put(actions.updateArcAdFailure())
      message.error('Failed to update arc ad')
    }
  } catch (error) {
    console.error(error)
    yield put(actions.updateArcAdFailure())
    message.error('Failed to update arc ad')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* deleteArcAdWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    yield call(api.deleteArcAd, payload.id)
    message.success('Arc ad deleted successfully')
    if (payload.callback) {
      payload.callback()
    }
  } catch (error) {
    console.error(error)
    message.error('Failed to delete arc ad')
  } finally {
    yield put(actions.finishSaving())
  }
}

export default function* () {
  yield all([
    takeLatest(actions.fetchArcAds, fetchArcAdsWorker),
    takeLatest(actions.fetchArcAdDetails, fetchArcAdDetailsWorker),
    takeLatest(actions.fetchArcAdSources, fetchArcAdSourcesWorker),
    takeLatest(actions.createArcAd, createArcAdWorker),
    takeLatest(actions.updateArcAd, updateArcAdWorker),
    takeLatest(actions.deleteArcAd, deleteArcAdWorker),
  ])
}